import React, { useEffect } from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { cn } from '../Button';

export type ToastType = 'success' | 'error';

export interface ToastMessage {
  type: ToastType;
  message: string;
}

interface ToastProps {
  notice: ToastMessage | null;
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ notice, onClose, duration = 4000 }) => {
  useEffect(() => {
    if (!notice) return undefined;

    const timeout = window.setTimeout(onClose, duration);

    return () => window.clearTimeout(timeout);
  }, [duration, notice, onClose]);

  if (!notice) {
    return null;
  }

  return (
    <div
      role={notice.type === 'error' ? 'alert' : 'status'}
      className={cn(
        'fixed right-4 top-4 z-[80] flex w-[calc(100vw-2rem)] max-w-sm items-start gap-3 rounded-2xl border p-4 text-sm font-semibold shadow-lg shadow-slate-900/10',
        notice.type === 'success'
          ? 'border-emerald-200 bg-emerald-600 text-white'
          : 'border-rose-200 bg-rose-600 text-white'
      )}
    >
      {notice.type === 'success' ? (
        <CheckCircle2 size={20} className="mt-0.5 shrink-0" />
      ) : (
        <XCircle size={20} className="mt-0.5 shrink-0" />
      )}
      <span className="leading-5">{notice.message}</span>
    </div>
  );
};

export default Toast;
